import { View } from "moti";
import { Platform, StyleSheet } from "react-native";
import { MagnifyingGlass } from "@phosphor-icons/react";

import CustomTextInput from "../CustomTextInput/CustomTextInput";

const CustomSearchInput = ({
  placeholder = "Search by any value",
  searchQuery,
  setSearchQuery,
}: {
  placeholder?: string;
  searchQuery: string;
  setSearchQuery: (value: string) => void;
}) => {
  return (
    <View style={styles.searchContainer}>
      <MagnifyingGlass size={16} color="#64748b" style={styles.searchIcon} />
      <CustomTextInput
        placeholder={placeholder}
        placeholderTextColor="#9CA3AF"
        selectionColor="#6B7280"
        cursorColor="#6B7280"
        value={searchQuery}
        onChangeText={setSearchQuery}
        style={[
          styles.searchInput,
          Platform.select({
            web: {
              outlineStyle: "none",
              outlineWidth: 0,
              WebkitAppearance: "none",
            } as unknown,
          }),
        ]}
      />
    </View>
  );
};

export default CustomSearchInput;

const styles = StyleSheet.create({
  searchContainer: {
    minWidth: 250,
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    borderWidth: 1,
    borderColor: "#E5E7EB",
    borderRadius: 6,
    paddingVertical: 4,
    paddingHorizontal: 12,
  },
  searchIcon: {
    marginRight: 8,
    flexShrink: 0,
  },
  searchInput: {
    flex: 1,
    borderWidth: 0,
    backgroundColor: "transparent",
    padding: 8,
    fontSize: 14,
    color: "#374151",
  },
});
